<template>
    <div class="container-fluid">
        <div class="loading-state" v-if="loading">
            <ProgressSpinner fill="transparent" aria-label="Loading" />
        </div>
        <div class="row mb-5">
            <div class="col-12">
                <ul id="dfTab" class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button"
                            role="tab" aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
                            {{ $t("content.gkeeptkhis") }}
                        </button>
                    </li>

                    <li class="nav-item" role="presentation">
                        <button id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button"
                            role="tab" aria-controls="tab2" aria-selected="false" @click="onClickTab('2')">
                            {{ $t("content.gdeposittk") }}
                        </button>
                    </li>

                    <li class="nav-item" role="presentation">
                        <button id="tab3-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3" type="button"
                            role="tab" aria-controls="tab3" aria-selected="false" @click="onClickTab('3')">
                            {{ $t("content.gwithdrawtk") }}
                        </button>
                    </li>
                </ul>

                <div id="dfTabContent" class="tab-content">
                    <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="card mt-3">
                            <div class="card-header mb-0">
                                <h5>{{ $t("content.gkeeptkhis") }}</h5>
                            </div>
                            <div class="card-body pt-2">
                                <div class="row">
                                    <div class="col-lg-3 mt-0">
                                        <fieldset>
                                            <div class="item">
                                                <material-checkbox v-model="time_h" :checked="time_h" name="autoSelect"
                                                    @change="onserachDate_h">
                                                    <label class="form-label m-0">{{ $t("content.sdate") }}</label>
                                                </material-checkbox>
                                                <VueDatePicker v-model="start_date" :format="format_h" auto-apply
                                                    :teleport="true" :max-date="new Date().setHours(23, 59, 59)"
                                                    :enable-time-picker="true" month-name-format="long"
                                                    :clearable="false" fluid :disabled="!time_h"
                                                    :text-input="textInputOptions_h" />
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div class="col-lg-3 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                                        <VueDatePicker v-model="end_date" :format="format_h" auto-apply :teleport="true"
                                            :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true"
                                            month-name-format="long" :clearable="false" :text-input="textInputOptions_h"
                                            :disabled="!time_h" fluid />
                                    </div>

                                    <div class="col-lg-4 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.names") }}</label>
                                        <div class="input-group">
                                            <input v-model="cusNameh_search" type="text" class="form-control"
                                                aria-describedby="searchName" readonly />
                                            <button class="btn btn-primary" type="button" @click="openDialogCusH">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                            </button>
                                            <button id="searchNameCus" class="btn btn-primary" type="button"
                                                data-bs-toggle="modal" data-bs-target="#searchNameModal" v-show="false">
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-lg-3">
                                        <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                                        <material-input type="text" v-model="tkh_search" />
                                    </div>
                                    <div class="col-lg-3">
                                        <label class="form-label ms-0">{{ $t("content.gkeepno") }}</label>
                                        <material-input type="text" v-model="tknoh_search" />
                                    </div>
                                    <div class="col-lg-2">
                                        <label class="form-label ms-0">{{ $t("content.type") }}</label>
                                        <select v-model="typetkh_search" class="form-select">
                                            <option value="">{{ $t('content.optall') }}</option>
                                            <option value="DEPOSIT">{{ $t('content.depo') }}</option>
                                            <option value="WITHDRAW">{{ $t('content.withd') }}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-2">
                                        <label class="form-label ms-0">{{ $t("content.amnchannel") }}</label>
                                        <select v-model="channeltkh_search" class="form-select">
                                            <option value="">{{ $t('content.optall') }}</option>
                                            <option value="SHOP">{{ $t('content.gchshop') }}</option>
                                            <option value="LINE_LIFF">{{ $t('content.gchonline') }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-3 d-flex justify-content-between align-items-center"></div>
                                    <div class="col-9 d-flex justify-content-end align-items-center">
                                        <div class="me-3">
                                            <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                                                :disabled="(!time_h && cusNameh_search === '' && tkh_search === '' && tknoh_search === '') || (time && start_date > end_date)"
                                                @click="loadHistoryListApi">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                                {{ search }}
                                            </material-button>
                                        </div>
                                        <div class="me-3">
                                            <material-button color="danger" class="float-lg-start float-sm-end mb-3"
                                                @click="cancelBtnH">
                                                <i class="material-icons material-symbols-outlined">close</i>
                                                {{ cancel }}
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-end align-items-center">
                                        <label class="form-label m-0 me-2">{{ $t("content.expfile") }} :</label>
                                        <div>
                                            <material-button id="pdfBtn" color="info" variant="outline"
                                                class="float-lg-start float-sm-end mb-0 me-2"
                                                :disabled="listhistory.length === 0 || !time_h" @click="pdfHistoryGen">
                                                <i class="material-icons material-symbols-outlined">picture_as_pdf</i>
                                                pdf
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                                <pre></pre>
                                <div class="row mt-3">
                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>{{ $t("content.gdpwdtkdate") }}</th>
                                                    <th>{{ $t("content.gkeepno") }}</th>
                                                    <th>{{ $t("content.amnticketold") }}</th>
                                                    <th>{{ $t("content.ticketno") }}</th>
                                                    <th>{{ $t("content.trans") }}</th>
                                                    <th>{{ $t("content.names") }}</th>
                                                    <th>{{ $t("content.gkeepmaker") }}</th>
                                                    <th>{{ $t("content.type") }}</th>
                                                    <th>{{ $t("content.amnchannel") }}</th>
                                                    <th>{{ $t("content.userwittk") }}</th>
                                                    <th>{{ $t("content.amnmaker") }}</th>
                                                    <th>{{ $t("content.act") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr v-for="(row, index) in listhistory" :key="index">
                                                    <td class="text-sm font-weight-normal">
                                                        {{ formatNumberString((currentPageH - 1) * perPageH + index
                                                            + 1)
                                                        }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ format_datetime(row.createDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.refNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.prevTkRefNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkRefNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ checkTransaction(row.txType) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkCusName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.cusName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <span v-if="row.type === 'DEPOSIT'">
                                                            {{ $t("content.stdeposittk") }}
                                                        </span>
                                                        <span v-else>
                                                            {{ $t("content.stwithdrawtk") }}
                                                        </span>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <span v-if="row.channel === 'SHOP'">
                                                            {{ $t("content.gchshop") }}
                                                        </span>
                                                        <span v-else>
                                                            {{ $t("content.gchonline") }}
                                                        </span>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.withdrawerName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.userName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" :title="t('buttons.seed')"
                                                            @click="openDetail(row.workCaseUid)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">visibility</i>
                                                        </material-button>
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" v-show="false" data-bs-toggle="modal"
                                                            data-bs-target="#lookupModal" id="detailModal">
                                                        </material-button>
                                                    </td>
                                                </tr>
                                                <tr v-if="listhistory.length === 0">
                                                    <td colspan="12" class="text-sm font-weight-normal">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="15" style="text-align: right">Total Rows : {{
                                                        totalRows_sH }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <pre></pre>
                                <div style="display: flex; justify-content: flex-end">
                                    <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPageH" :total-items="totalRowsH"
                                                    :items-per-page="perPageH" @click="onClickHandlerH" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
                        <div class="card mt-3">
                            <div class="card-header mb-0">
                                <h5>{{ $t("content.gdeposittk") }}</h5>
                            </div>
                            <div class="card-body pt-3">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <label class="form-label ms-0">{{ $t("content.names") }}</label>
                                        <div class="input-group">
                                            <input v-model="cusNamed_search" type="text" class="form-control"
                                                aria-describedby="searchName" readonly />
                                            <button class="btn btn-primary" type="button" @click="openDialogCusD">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                            </button>
                                            <button id="searchNameCus" class="btn btn-primary" type="button"
                                                data-bs-toggle="modal" data-bs-target="#searchNameModal" v-show="false">
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-lg-3">
                                        <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                                        <material-input type="text" v-model="tkd_search" />
                                    </div>

                                </div>
                                <div class="row mt-4">
                                    <div class="col-3 d-flex justify-content-between align-items-center"></div>
                                    <div class="col-9 d-flex justify-content-end align-items-center">
                                        <div class="me-3">
                                            <material-button id="cardSearch" color="primary"
                                                class="float-lg-start float-sm-end mb-3"
                                                :disabled="cusNamed_search === '' && tkd_search === ''"
                                                @click="loadDepositListApi">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                                {{ search }}
                                            </material-button>
                                        </div>
                                        <div class="me-3">
                                            <material-button id="cardSearch" color="danger"
                                                class="float-lg-start float-sm-end mb-3" @click="cancelBtnD">
                                                <i class="material-icons material-symbols-outlined">close</i>
                                                {{ cancel }}
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="row mt-3">
                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>{{ $t("content.lasttrf") }}</th>
                                                    <th>{{ $t("content.names") }}</th>
                                                    <th>{{ $t("content.amnticketold") }}</th>
                                                    <th>{{ $t("content.ticketno") }}</th>
                                                    <th>{{ $t("content.trans") }}</th>
                                                    <th>{{ $t("content.amnweightvalall") }}</th>
                                                    <th>{{ $t("content.amnqtyunitall") }}</th>
                                                    <th>{{ $t("content.amnpriceall") }}</th>
                                                    <th>{{ $t("content.gkeepstatus") }}</th>
                                                    <th>{{ $t("content.amnlastmaker") }}</th>
                                                    <th>{{ $t("content.act") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr v-for="(row, index) in listdepo" :key="index"
                                                    :class="row.paySide == 'PAY' && row.migration ? 'bg-redeem'
                                                        : row.paySide == 'PAY' && !row.migration ? 'bg-payment'
                                                            : row.paySide === 'RECEIVE' && row.migration ? 'bg-reduce-cap'
                                                                : row.paySide === 'RECEIVE' && !row.migration ? 'bg-receive'
                                                                    : row.paySide === 'NONE' && row.migration ? 'bg-nonemi' : 'bg-none'">
                                                    <td class="text-sm font-weight-normal">
                                                        {{ formatNumberString((currentPageD - 1) * perPageD + index
                                                            +
                                                            1) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ format_datetime(row.createDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <span v-if="row.changeName">
                                                            {{ row.customerName }}
                                                        </span>
                                                        <span v-else>
                                                            {{ row.tkCustomerName }}
                                                        </span>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.refNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <span v-if="row.represent">
                                                            <span v-if="row.migration">
                                                                {{ checkTransaction(row.type) }} ({{
                                                                    checkTransaction(row.migrationType) }},ทำแทน)
                                                            </span>
                                                            <span v-else>
                                                                {{ checkTransaction(row.type) }} (ทำแทน)
                                                            </span>
                                                        </span>
                                                        <span v-else-if="row.shopRepresent">
                                                            <span v-if="row.migration">
                                                                {{ checkTransaction(row.type) }} ({{
                                                                    checkTransaction(row.migrationType) }},ออนไลน์)
                                                            </span>
                                                            <span v-else>
                                                                {{ checkTransaction(row.type) }} (ออนไลน์)
                                                            </span>
                                                        </span>
                                                        <span v-else-if="row.changeName">
                                                            <span v-if="row.migration">
                                                                {{ checkTransaction(row.type) }} ({{
                                                                    checkTransaction(row.migrationType)
                                                                }},เปลี่ยนชื่อ)
                                                            </span>
                                                            <span v-else>
                                                                {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ)
                                                            </span>
                                                        </span>
                                                        <span v-else>
                                                            <span v-if="row.migration">
                                                                {{ checkTransaction(row.type) }} ({{
                                                                    checkTransaction(row.migrationType) }})
                                                            </span>
                                                            <span v-else>
                                                                {{ checkTransaction(row.type) }}
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">{{
                                                        formatNumberDecimalString(row.weight) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">{{
                                                        formatNumberDecimalString(row.quantity) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ formatNumberDecimalString(row.pawnValue) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <span v-if="row.deposit">
                                                            {{ $t("content.stadeposittk") }}
                                                        </span>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">{{ row.shopManagerName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" :title="t('buttons.seed')"
                                                            @click="openDetail(row.uid)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">visibility</i>
                                                        </material-button>
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" v-show="false" data-bs-toggle="modal"
                                                            data-bs-target="#lookupModal" id="detailModal">
                                                        </material-button>
                                                        <material-button color="secondary" variant="outline"
                                                            class="rounded-circle" :title="t('content.mdeposittk')"
                                                            :disabled="row.deposit" @click="onDepositTicketDialog(row)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">post_add</i>
                                                        </material-button>
                                                    </td>


                                                </tr>
                                                <tr v-if="listdepo.length === 0">
                                                    <td colspan="11" class="text-sm font-weight-normal">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="15" style="text-align: right">Total Rows : {{
                                                        totalRows_Ds }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <pre></pre>
                                <div style="display: flex; justify-content: flex-end">
                                    <ul v-show="listdepo.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPageD" :total-items="totalRowsD"
                                                    :items-per-page="perPageD" @click="onClickHandlerD" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="tab3" class="tab-pane fade" role="tabpanel" aria-labelledby="tab3-tab">
                        <div class="card mt-3">
                            <div class="card-header mb-0">
                                <h5>{{ $t("content.gwithdrawtk") }}</h5>
                            </div>
                            <div class="card-body pt-3">
                                <div class="row">
                                    <div class="col-lg-3 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.names") }}</label>
                                        <div class="input-group">
                                            <input v-model="cusNamew_search" type="text" class="form-control"
                                                aria-describedby="searchName" readonly />
                                            <button class="btn btn-primary" type="button" @click="openDialogCusW">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                            </button>
                                            <button id="searchNameCus" class="btn btn-primary" type="button"
                                                data-bs-toggle="modal" data-bs-target="#searchNameModal" v-show="false">
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                                        <material-input type="text" v-model="tkw_search" />
                                    </div>

                                    <div class="col-lg-3 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.gkeepno") }}</label>
                                        <material-input type="text" v-model="tknow_search" />
                                    </div>

                                    <div class="col-lg-3">
                                        <fieldset>
                                            <div class="item">
                                                <material-checkbox v-model="time" :checked="time" name="autoSelect"
                                                    @change="onserachDate">
                                                    <label class="form-label m-0">{{ $t("content.txdatetk")
                                                    }}</label>
                                                </material-checkbox>

                                                <select class="form-select" v-model="withTxDate" :disabled="!time">
                                                    <option disabled value="">{{ $t('content.select') }}</option>
                                                    <option v-for="n in 31" :key="n" :value="n">{{ n }}</option>
                                                </select>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-3 d-flex justify-content-between align-items-center"></div>
                                    <div class="col-9 d-flex justify-content-end align-items-center">
                                        <div class="me-3">
                                            <material-button id="cardSearch" color="primary"
                                                class="float-lg-start float-sm-end mb-3" @click="loadWithdrawListApi"
                                                :disabled="time && withTxDate === ''">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                                {{ search }}
                                            </material-button>
                                        </div>
                                        <div class="me-3">
                                            <material-button id="cardSearch" color="danger"
                                                class="float-lg-start float-sm-end mb-3" @click="cancelBtnW">
                                                <i class="material-icons material-symbols-outlined">close</i>
                                                {{ cancel }}
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="row no-gutters">
                                    <div class="col-3 d-flex justify-content-between align-items-center">
                                        <material-button color="secondary" class="float-lg-start float-sm-end mb-3"
                                            variant="outline" @click="onWithdrawTicketDialog"
                                            :disabled="listwith.length === 0 || !canwith">
                                            <i class="material-icons material-symbols-outlined">done_all</i>
                                            {{ t('content.mwithdrawtk') }}
                                        </material-button>

                                    </div>
                                    <div class="col-9 d-flex justify-content-end align-items-center">
                                        <label class="form-label m-0 me-2">{{ $t("content.expfile") }} :</label>
                                        <div>
                                            <material-button id="pdfBtn" color="info" variant="outline"
                                                class="float-lg-start float-sm-end mb-0 me-2"
                                                :disabled="listwith.length === 0" @click="pdfDepositGen">
                                                <i class="material-icons material-symbols-outlined">picture_as_pdf</i>
                                                pdf
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                                <pre></pre>
                                <div class="row mt-3">
                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="text-sm font-weight-normal text-center">
                                                        <material-checkbox v-model="allWith" :checked="allWith"
                                                            @change="setAllTk()" :disabled="listwith.length === 0">
                                                        </material-checkbox>
                                                    </th>
                                                    <th>#</th>
                                                    <th>{{ $t("content.gdpwdtkdate") }}</th>
                                                    <th>{{ $t("content.lasttrf") }}</th>
                                                    <th>{{ $t("content.gkeepno") }}</th>
                                                    <th>{{ $t("content.amnticketold") }}</th>
                                                    <th>{{ $t("content.ticketno") }}</th>
                                                    <th>{{ $t("content.trans") }}</th>
                                                    <th>{{ $t("content.names") }}</th>
                                                    <th>{{ $t("content.gkeepmaker") }}</th>
                                                    <th>{{ $t("content.type") }}</th>
                                                    <th>{{ $t("content.amnchannel") }}</th>
                                                    <th>{{ $t("content.amnmaker") }}</th>
                                                    <th>{{ $t("content.act") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr v-for="(row, index) in listwith" :key="index">
                                                    <td class="text-sm font-weight-normal">
                                                        <material-checkbox v-model="row.chk" :checked="row.chk"
                                                            @change="setTk(row)">
                                                        </material-checkbox>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ formatNumberString((currentPageW - 1) * perPageW + index
                                                            +
                                                            1) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ format_datetime(row.createDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ format_datetime(row.txDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.refNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.prevTkRefNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkRefNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ checkTransaction(row.txType) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkCusName }}
                                                    </td>

                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.cusName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ $t("content.stdeposittk") }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <span v-if="row.channel === 'SHOP'">
                                                            {{ $t("content.gchshop") }}
                                                        </span>
                                                        <span v-else>
                                                            {{ $t("content.gchonline") }}
                                                        </span>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.userName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" :title="t('buttons.seed')"
                                                            @click="openDetail(row.workCaseUid)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">visibility</i>
                                                        </material-button>
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" v-show="false" data-bs-toggle="modal"
                                                            data-bs-target="#lookupModal" id="detailModal">
                                                        </material-button>
                                                        <!-- <material-button color="secondary" variant="outline"
                                                            class="rounded-circle" :title="t('content.mwithdrawtk')"
                                                            :disabled="row.deposit"
                                                            @click="onWithdrawTicketDialog(row)">
                                                            <i class="material-icons material-symbols-outlined">
                                                                done_all</i>
                                                        </material-button> -->
                                                        <material-button color="success"
                                                            class="float-lg-start float-sm-end mb-3"
                                                            data-bs-toggle="modal" data-bs-target="#withdrawModal"
                                                            id="withdrawModalShow" v-show="false">
                                                        </material-button>
                                                        <material-button id="fingerModal" color="primary"
                                                            class="float-lg-start float-sm-end mb-3"
                                                            data-bs-toggle="modal" data-bs-target="#fingerModalNew"
                                                            v-show="false">
                                                        </material-button>
                                                    </td>
                                                </tr>
                                                <tr v-if="listwith.length === 0">
                                                    <td colspan="12" class="text-sm font-weight-normal">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="15" style="text-align: right">Total Rows : {{
                                                        totalRows_Ws }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <pre></pre>
                                <div style="display: flex; justify-content: flex-end">
                                    <ul v-show="listwith.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPageW" :total-items="totalRowsW"
                                                    :items-per-page="perPageW" @click="onClickHandlerW" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Search Customer Dialog -->
                <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                    id="closeModal">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                </button>
                            </div>

                            <div class="modal-body">
                                <div class="preview-table">
                                    <section class="panel">
                                        <table class="table table-striped table-responsive">
                                            <thead>
                                                <tr>

                                                    <th>#</th>
                                                    <th>{{ $t("content.cnameth") }}</th>
                                                    <th>{{ $t("content.cnameen") }}</th>
                                                    <th>{{ $t("content.docno") }}</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="row-search">
                                                    <td></td>
                                                    <td>
                                                        <material-input v-model="nameThC" type="text"
                                                            :label="t('content.cnameth')" />
                                                    </td>
                                                    <td>
                                                        <material-input v-model="nameEnC" type="text"
                                                            :label="t('content.cnameen')" />
                                                    </td>
                                                    <td>
                                                        <material-input v-model="docNumberC" type="text"
                                                            :label="t('content.docno')" />
                                                    </td>
                                                    <td>
                                                        <material-button color="primary" variant="contain"
                                                            class="rounded-circle ms-1" data-bs-toggle="tooltip"
                                                            data-bs-placement="top" :title="btnSearch"
                                                            :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                                            @click="loadCustomerListApi">
                                                            <i
                                                                class="material-icons material-symbols-outlined">search</i>
                                                        </material-button>
                                                    </td>
                                                </tr>
                                                <tr v-for="(row, index) in customerlist" :key="index"
                                                    @click="selectCus(row)">
                                                    <td>{{ formatNumberString((currentPageC - 1) * perPageC + index
                                                        + 1)
                                                    }}</td>
                                                    <td>{{ row.nameTh }}</td>
                                                    <td>{{ row.nameEn }}</td>
                                                    <td colspan="2">{{ row.docNumber }}</td>
                                                </tr>
                                                <tr v-if="customerlist.length === 0">
                                                    <td colspan="5" class="text-sm font-weight-normal">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </section>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <pre></pre>
                                <div style="display: flex; justify-content: flex-end">
                                    <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                                                    :items-per-page="perPageC" @click="onClickHandlerC" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Detail Modal -->
          <div id="lookupModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                  <div style="display: flex; justify-content: flex-end">
                    <div>
                      <div class="d-inline-block mx-4">
                      </div>
                    </div>
                    <div>
                      <div class="d-inline-block mx-4">
                      </div>
                    </div>
                    <div>
                      <div class="d-inline-block mx-4">
                        <material-checkbox id="infocus" v-model="fcusdt" :checked="fcusdt">
                          {{ $t("content.infofcus") }}
                        </material-checkbox>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="row">
                    <div class="col-lg-6 mt-2">
                      <div id="lookupImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false"
                        style="max-width: 520px">
                        <div class="carousel-indicators" id="demo1">
                        </div>
                        <div class="carousel-inner">
                          <ul className="list-unstyled">
                            <li v-for="(item, index) in images.length" :key="index">
                              <span v-if="index === 0">
                                <div class="carousel-item active">
                                  <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                    class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                    message-pos="top" />
                                </div>
                              </span>
                              <span v-else>
                                <div class="carousel-item">
                                  <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                    class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                    message-pos="top" />
                                </div>
                              </span>
                            </li>
                          </ul>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages"
                          data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#lookupImages"
                          data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-6 mt-2">
                      <div v-if="workcaseDetail !== null" style="overflow-x:auto;">
                        <div>
                          <table class="table table-sm table-borderless">
                            <tbody>
                              <tr>
                                <td class="fs-14 text-bold">{{ $t("content.ticketno") }} :
                                  <span v-if="workcaseDetail.tkRefNumber !== ''">
                                    {{ workcaseDetail.tkRefNumber }} &nbsp;
                                    <span @click='copyBtn()' style="cursor: pointer">
                                      <i class="inline-icon material-icons">content_copy</i>
                                    </span>
                                  </span>
                                  <span v-else>-</span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.stkeeptk") }} :
                                  <span v-if="workcaseDetail.deposit" style="color:green;">
                                    {{ $t("content.stdeposittk") }} ({{ dep_ref }})
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-bold">{{ $t("content.trans") }} :
                                  {{ checkTransaction(workcaseDetail.transactionType) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.statusticket") }} :
                                  <span v-if="workcaseDetail.status === 'FINISH'" style="color:green;">
                                    {{ tk_status }}
                                  </span>
                                  <span v-else-if="workcaseDetail.status === 'FREEZE' || workcaseDetail.status === 'TERMINATE'
                                    || workcaseDetail.status === 'BREAKING'" style="color:red;">
                                    <span v-if="workcaseDetail.status === 'BREAKING'">
                                      {{ tk_status }} ({{ format_date(workcaseDetail.breakingDate) }} : {{
                                        workcaseDetail.lotNumber }})
                                    </span>
                                    <span v-else>
                                      {{ tk_status }}
                                    </span>
                                  </span>
                                  <span v-else>
                                    {{ tk_status }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount === 0">
                                <td class="fs-14 text-bold"> {{ $t("content.lasttrf") }} : {{
                                  format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.amnduedate") }} :
                                  <span style="color:red;">
                                    {{ format_date(workcaseDetail.dueDate) }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.lasttrf") }} : {{
                                  format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2">
                                  {{ $t("content.amnduedate") }} :
                                  <span style="color:red;">
                                    {{ format_date(workcaseDetail.dueDate) }} (ขอเลื่อนเป็นวันที่ {{
                                      format_date(workcaseDetail.postponeDate) }})
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2">
                                  {{ $t("content.deferpast") }} :
                                  <span @click='NewTab()' style="text-decoration: underline;color:red; cursor: pointer">
                                    {{ workcaseDetail.postponeCount }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.monthlyprofn") }} : {{
                                    formatNumberDecimalString(workcaseDetail.interestPerMonth) }}
                                  <span style="color:red;">
                                    ({{ format_date(new Date()) }})
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.currentprof") }} :
                                  <span style="color:red;">
                                    {{ formatNumberDecimalString(int_cal) }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">
                                  {{ $t("content.ttprointerest") }} :
                                  <span
                                    v-if="workcaseDetail.interestPromotion === null || workcaseDetail.interestPromotion === 0">
                                    -
                                  </span>
                                  <span style="color:blue;" v-else>
                                    {{ formatNumberDecimalString(workcaseDetail.interestPromotion) }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.periodpromotion") }} :
                                  <span v-if="workcaseDetail.promotionDuration === 0">
                                    -
                                  </span>
                                  <span style="color:blue;" v-else>
                                    {{ workcaseDetail.promotionDuration }} เดือน
                                  </span>
                                </td>
                              </tr>
                              <template v-if="!fcusdt && workcaseDetail.interestPromotion !== 0 && promotionDetail !== null">
                                <tr v-for="(item, index) in promotionDetail.interests" :key="item.id">
                                    <div v-if="item.promotion" class="fs-14 text-bold" style="display: flex; width: 100%;">
                                        <!-- คอลัมน์ซ้าย: กำหนดความกว้างคงที่เพื่อให้ย่อหน้าตรงกัน -->
                                        <div style="width: 70px;">
                                            เดือนที่ {{ index + 1 }} :
                                        </div>
                                        <!-- คอลัมน์ขวา: แสดงตัวเลขสีน้ำเงิน -->
                                        <div style="color:blue;">
                                            {{ item.interestVal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                                        </div>
                                    </div>
                                </tr>
                              </template>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.periodpawnn") }} :
                                  <span style="color:blue;">
                                    {{ int_period }} เดือน
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.amnbookno") }}
                                  <span style="color:blue;">
                                    {{ workcaseDetail.tkVolNo }}
                                  </span>
                                  &nbsp;{{ $t("content.amnno") }}
                                  <span style="color:blue;">
                                    {{ workcaseDetail.tkNo }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-else>
                                <td class="fs-14 text-bold" colspan="2">{{ $t("content.periodpawnn") }} :
                                  <span style="color:blue;">
                                    {{ int_period }} เดือน
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.amnqtypiece") }} :
                                  {{ formatNumberString(workcaseDetail.ticket.totalQuantity) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.allweight") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.ticket.totalWeight) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.pawnvalpv") }} :
                                  <span v-if="workcaseDetail.transactionType === 'PAWN'">
                                    {{ formatNumberDecimalString(0) }}
                                  </span>
                                  <span v-else>
                                    {{ formatNumberDecimalString(workcaseDetail.pawnValue) }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.actpawn3") }}/{{ $t("content.actpawn4") }}
                                  :
                                  {{ formatNumberDecimalString(workcaseDetail.diffValue) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.amnanalysval") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.amnmaxvalall") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.ticket.totalFullValue) }}
                                </td>
                              </tr>
                              <tr v-else>
                                <td class="fs-14 text-bold" colspan="2">{{ $t("content.amnanalysval") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.statusticketlost") }} :
                                  <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> ไม่มี
                                  </span>
                                  <span v-else style="color:red;">
                                    มี ({{ workcaseDetail.lostCount }})
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.refnolost") }} :
                                  <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> -
                                  </span>
                                  <span v-else style="color:red;">
                                    {{ workcaseDetail.lostRefNumber }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.represent || workcaseDetail.shopRepresent && !fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.represent") }} :
                                    <span style="color:red;">
                                    {{workcaseDetail.customerInfo.name}}
                                </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.changeName && !fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.changeName") }} ({{ bf_changename }}) :
                                    <span style="color:red;">
                                    {{ af_changename }}
                                    </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.transoutage") }} :
                                    <span v-if="workcaseDetail.outage" style="color:red">
                                    {{ $t("content.yes") }}
                                    </span>
                                    <span v-else style="color:green">
                                    {{ $t("content.no") }}
                                    </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.amnlocationasset") }} :
                                  <span v-if="workcaseDetail.ticket.locationName !== null">
                                    {{ workcaseDetail.ticket.locationName }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.stockno") }} :
                                  <span v-if="workcaseDetail.ticket.stockNumber !== null">
                                    {{ workcaseDetail.ticket.stockNumber }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.migraref") }} :
                                  <span v-if="workcaseDetail.migrateRefNumber !== null">
                                    {{ workcaseDetail.migrateRefNumber }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <span v-if="!fcusdt">
                            <span v-if="listinfo.length !== 0">
                              <table class="table table-sm table-borderless">
                                <tbody>
                                  <tr>
                                    <td class="fs-14 text-bold">
                                      <span style="text-decoration:underline;">
                                        {{ $t("content.amnassetdetail") }}
                                      </span>
                                    </td>
                                  </tr>

                                  <tr v-for="(row, index) in listinfo" :key="index">
                                    <td class="fs-14 text-bold">
                                      {{ formatNumberString(index + 1) }}. {{ row.remark }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </span>
                            <span v-else>
                              <tr>
                                <td class="fs-14 text-bold">
                                  <span style="text-decoration:underline;">
                                    {{ $t("content.amnassetdetail") }}
                                  </span>
                                  : -
                                </td>
                              </tr>
                            </span>
                          </span>
                          <span v-else>
                            <table class="table table-sm table-borderless">
                              <tbody>
                                <tr>
                                  <td class="fs-14 text-bold">
                                    <span style="text-decoration:underline;">
                                      {{ $t("content.amngrandtotal") }}
                                    </span> :
                                    {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }} + {{
                                      formatNumberDecimalString(int_cal) }} =
                                    <span style="color:blue;">
                                      {{ formatNumberDecimalString(Number(workcaseDetail.newPawnValue) +
                                        Number(int_cal))
                                      }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </span>



                        </div>
                      </div>
                    </div>
                  </div>
                  <hr v-if="paymentE !== ''" />
                  <div class="col-12 mt-2" v-if="paymentE !== ''">
                    <div class="fs-14 text-bold">
                      <span style="text-decoration:underline;">
                        {{ $t("content.amnfinanceinfo") }}
                      </span>
                    </div>
                    <pre></pre>
                    <div class="row">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th>#</th>
                              <th>{{ $t("content.ticketno") }}</th>
                              <th>{{ $t("content.amnbiz") }}</th>
                              <th colspan="5" class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnincome") }}
                                </span>
                              </th>
                              <th colspan="4" class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnoutcome") }}
                                </span>
                              </th>
                              <th colspan="4" class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.fee") }}
                                </span>
                              </th>
                            </tr>
                            <tr>
                              <th colspan="3"></th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="2" class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncreditcard") }}
                                </span>

                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncheque") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="3" class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="2" class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amncreditcard") }}
                                </span>
                              </th>
                            </tr>
                            <tr>
                              <th colspan="3"></th>
                              <th style="background-color:#dfffdd;"></th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  QR Code
                                </span>
                              </th>
                              <th colspan="2" style="background-color:#dfffdd;"></th>
                              <th style="background-color:#fecac7;"></th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amntransfer_promt_mobile") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amntransfer_promt_taxid") }}
                                </span>
                              </th>
                              <th style="background-color:#CFEBFD;"></th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  QR Code
                                </span>
                              </th>
                              <th style="background-color:#CFEBFD;"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in paymentE.workCases" :key="index">
                              <template v-if="row.ticket !== null">
                                <td class="text-sm font-weight-normal text-center">{{ formatNumberString(index + 1) }}
                                </td>
                                <td class="text-sm font-weight-normal text-center">{{ row.tkRefNumber }}</td>
                                <td class="text-sm font-weight-normal text-center">{{
                                  checkTransaction(row.transactionType) }}</td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[0].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[1].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[6].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[6].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[2].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[2].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[3].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[3].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[0].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[1].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[4].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[4].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[5].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[5].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[0].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[1].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[6].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[6].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[2].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[2].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



                <!-- New Finger Scan Dialog  -->
                <div id="fingerModalNew" class="modal fade" tabindex="-1" aria-labelledby="fingerModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-sm" style="max-width: 500px;height:auto">
                        <div class="modal-content">
                            <div class="modal-header justify-content-center">
                                <h5 class="modal-title text-center">{{ $t("content.amnfingerscan") }} : {{
                                    cus_detail.nameTh }}</h5>
                            </div>

                            <div class="modal-body">
                                <h5 v-if="template_1 !== '' && template_2 !== ''" class="text-center mt-2"
                                    :class="matchResult > idQuality ? `text-success` : `text-danger`">
                                    MATCH SCORE : {{ matchResult }}
                                </h5>
                                <section class="panel">
                                    <div class="row" v-if="bmpBase64f_1 !== '' || bmpBase64f_2 !== ''">
                                        <div class="col-12">

                                        </div>
                                        <div class="col-6">
                                            <figure class="figure w-100">
                                                <figcaption class="figure-caption text-center">
                                                    <b>Before</b>
                                                </figcaption>
                                                <img id="FPImage1" :src="Finger1"
                                                    class="img img-fluid figure-img rounded" width="300" height="250" />
                                            </figure>
                                        </div>
                                        <div class="col-6">
                                            <figure class="figure w-100">
                                                <figcaption class="figure-caption text-center">
                                                    <b>After</b>
                                                </figcaption>
                                                <img id="FPImage2" class="img img-fluid figure-img rounded" width="300"
                                                    height="250" />
                                            </figure>
                                        </div>
                                    </div>
                                    <div class="row" v-else>
                                        <div class="col-12 text-center">
                                            <figure class="figure w-100">
                                                <figcaption class="figure-caption text-center">
                                                </figcaption>
                                                <img id="FPImage2" class="img img-fluid figure-img rounded" width="300"
                                                    height="250" />
                                            </figure>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button type="button" class="btn btn-info btn-lg"
                                                :disabled="secugen_lic === ''"
                                                @click="CallSGIFPGetData(SuccessFunc2, ErrorFunc)">
                                                {{ newscan }}
                                            </button>

                                        </div>
                                    </div>
                                </section>
                            </div>

                            <div class="modal-footer">
                                <span class="me-auto">
                                    <button type="button" class="btn btn-outline-warning" data-bs-dismiss="modal"
                                        @click="requestOTP" v-show="count_fg >= 3 && template_2 !== ''">
                                        {{ $t(`content.reqotpcode`) }}
                                    </button>
                                </span>
                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                    @click="addWithdraw" :disabled="((matchResult < idQuality && template_1 !== '') && secugen_lic !== '')
                                        || ((template_1 === '' && template_2 === '') && secugen_lic !== '')">
                                    {{ confirm }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- OTP Dialog -->
                <div id="otpModal" class="modal fade" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true"
                    data-bs-keyboard="false" data-bs-backdrop="static">
                    <div class="modal-dialog" style="max-width: 800px">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title text-center">{{ $t("content.amnotpcode") }}</h4>
                                <button v-show="false" type="button" class="close" data-bs-dismiss="modal"
                                    aria-label="Close" id="closeOtp">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p class="text-center mt-3" v-if="otpMsg !== '' && otpMsg.indexOf('ไม่สำเร็จ') > -1">
                                    <span style="color: red">
                                        {{ otpMsg }}
                                    </span>
                                </p>
                                <p class="text-center mt-3" v-else-if="otpMsg !== ''">
                                    <span style="color: green">
                                        {{ otpMsg }}
                                    </span>
                                </p>
                                <p class=" text-center mt-3">
                                    {{ $t(`content.amnotpref`) }} :
                                    <span style="color: blue">
                                        {{ otpRef }}
                                    </span>
                                </p>
                                <section class="panel">
                                    <div class="d-flex justify-content-center mt-3">
                                        <InputOtp v-model="otpValue" integerOnly :length="6" style="gap: 1"
                                            size="large" />
                                    </div>
                                    <p class="text-center mt-3">
                                        {{ $t(`content.amnotptime`) }}
                                        <span style="color: #05472A" id="timer-otp"></span>
                                        {{ $t(`content.amnmin`) }}
                                    </p>
                                </section>

                                <pre></pre>
                                <pre></pre>
                                <pre></pre>


                                <div style="position: relative;width:100%;">
                                    <div style="position:absolute;left:0px;">
                                        <button type="button" class="btn btn-warning" :disabled="otpResend"
                                            @click="generateOTP('resend')">
                                            {{ $t(`content.resend_otp`) }}
                                        </button>&nbsp;
                                        <span v-show="otpResend">
                                            {{ $t(`content.reotptime`) }}
                                            <span style="color: #05472A" id="timer-resend"></span>
                                            {{ $t(`content.amnmin`) }}</span>
                                    </div>

                                    <div style="position:absolute;right:0px;">
                                        <button type="button" class="btn btn-primary" data-dismiss="modal"
                                            :disabled="String(otpValue).length !== 6" @click="validateOTPNew">
                                            {{ confirm }}{{ $t("content.amnotpcode") }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <pre></pre>
                            <pre></pre>
                            <pre></pre>

                            <hr />

                            <p class="text-center mt-2">
                                <span @click="onOpenFingerScan()"
                                    style="text-decoration: underline;color:blue; cursor: pointer">
                                    {{ $t("content.amnfingerprint") }}
                                </span>
                            </p>
                            <pre></pre>
                        </div>
                    </div>
                </div>



                <!-- QR Code Modal -->
                <div id="withdrawModal" class="modal fade" tabindex="-1" aria-labelledby="viewWithdrawModalLabel"
                    data-bs-keyboard="false" data-bs-backdrop="static" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-lg " style="max-width: 600px">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ $t("content.mwithdrawtk") }} : {{ with_list.length }}</h4>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                    id="closeqr" @click="paused = true">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-12" v-if="msg_with !== '' || error !== ''"
                                        style="overflow:auto;max-height:80px;">
                                        <p style="color:red;" v-if="msg_with !== ''"><b>{{ msg_with }}</b></p>
                                        <p style="color:red;" v-if="error !== ''">{{ error }}</p>
                                    </div>

                                    <div class="col-12" v-if="with_uid !== ''" style="overflow:auto;max-height:80px;">
                                        <span>
                                            <p style="color:blue;">
                                                <b>{{ $t("content.withtkref") }} : {{ with_uid }}</b>
                                            </p>
                                        </span>
                                    </div>

                                    <div class="col-12">
                                        <span class=" form-label m-0">{{ $t("content.scanwithtk") }}</span>
                                        <figure width="100px" height="100px">
                                            <qrcode-stream :paused="paused" @detect="onDetect" @error="onError"
                                                @camera-on="resetValidationState" :constraints="selectedConstraints"
                                                :track="trackFunctionSelected.value">
                                            </qrcode-stream>
                                        </figure>
                                    </div>

                                    <p class="text-center" @click="qr_scan = !qr_scan; qr_serach = ''">
                                        <span style="text-decoration: underline;color:orange; cursor: pointer">
                                            {{ $t("content.typewithtk") }}
                                        </span>
                                    </p>

                                    <div class="col-12" v-if="qr_scan">
                                        <span class="form-label m-0">{{ $t("content.searchwithtk") }}</span>
                                        <div class="input-group">
                                            <input type="search" v-model="qr_serach" class="form-control"
                                                :placeholder="t(`content.ticketno`)"
                                                style="margin-bottom: 0 !important" />
                                            <button class="btn btn-info mb-0" type="button" :disabled="qr_serach === ''"
                                                @click="onConfirmWith">
                                                <i class="material-icons material-symbols-outlined">check</i>
                                                {{ $t("buttons.conf") }}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="modal-footer justify-content-between">
                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                                    {{ cancel }}
                                </button>
                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                    :disabled="with_list.length === 0 || with_list.length !== uid_list.length"
                                    @click="checkbeforeScan">
                                    {{ $t("buttons.save") }}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>
<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, ref, computed, onMounted, inject, onUpdated } from "vue";
import { useI18n } from "vue-i18n";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import InputOtp from 'primevue/inputotp';
import Modal from 'bootstrap/js/dist/modal';
import InputNumber from 'primevue/inputnumber';
import { QrcodeStream } from 'vue-qrcode-reader'


import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"
import nofinger from "@/assets/img/noimg.png"

import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDepositStore } from '@/stores/deposit'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useShopStore } from '@/stores/shop'
import { useCusShopStore } from '@/stores/cusshop'
import { useDocumentStore } from '@/stores/document'
import { useUserSecurityStore } from "@/stores/usersecurity";


const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const storei = useInterestStore()
const storepay = usePaymentGroupStore()
const storedepo = useDepositStore()
const storeca = useCashAccountStore()
const storesh = useShopStore()
const storecussh = useCusShopStore()
const storedoc = useDocumentStore()
const userSStore = useUserSecurityStore()



const { t } = useI18n();
const swal = inject("$swal");

const search = computed(() => t("buttons.sear"));
const cancel = computed(() => t("buttons.canc"));
const confirm = computed(() => t("buttons.conf"));
const startscan = computed(() => t("buttons.sscan"));
const newscan = computed(() => t("buttons.nscan"));


const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const time_h = ref(false);
const cusUidh_search = ref('');
const cusNameh_search = ref('');
const tkh_search = ref('');
const tknoh_search = ref('');
const typetkh_search = ref('');
const channeltkh_search = ref('');
const listhistory = ref([]);
const shop_detail = ref(null)
const shop_info = ref(null)

const finger_uid = ref('0');
const finger_temp = ref('0');
const thumb_id = ref('');
const template_1 = ref('');
const template_2 = ref('');
const bmpBase64 = ref('');
const matchResult = ref(0);
const templatef_1 = ref('');
const templatef_2 = ref('');
const bmpBase64f_1 = ref('');
const bmpBase64f_2 = ref('');

const listdepo = ref([]);
const cusUidd_search = ref('');
const cusNamed_search = ref('');
const tkd_search = ref('');

const listwith = ref([]);
const cusUidw_search = ref('');
const cusNamew_search = ref('');
const tkw_search = ref('');
const with_uid = ref('0');
const withTxDate = ref('');
const time = ref(false);
const tknow_search = ref('');

const cusUidu_search = ref('');
const cusNameu_search = ref('');

const listinfo = ref([]);
const customerlist = ref([])
const workcaseDetail = ref(null);
const int_cal = ref(0);
const tk_status = ref('');
const int_period = ref('');
const cus_search = ref('');
const dep_ref = ref('');
const fcusdt = ref(false);
const bf_changename = ref('');
const af_changename = ref('');

const currentPageH = ref(1);
const totalRowsH = ref(1);
const perPageH = ref(30);
const totalRows_sH = ref();

const currentPageD = ref(1);
const totalRowsD = ref(1);
const perPageD = ref(30);
const totalRows_Ds = ref();

const currentPageW = ref(1);
const totalRowsW = ref(1);
const perPageW = ref(30);
const totalRows_Ws = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')

const images = ref([])
const images_l = ref([])
const payment_l = ref([])
const paymentE = ref('');

const loading = ref(false);

const cus_detail = ref({
    nameTh: '',
    nameEn: '',
    birthOrRegDate: new Date(),
    address: {
        address1: "",
        subDistrict: "",
        district: "",
        province: "",
        postcode: "",
        country: ""
    },
    issuedBy: '',
    issuedDate: new Date(),
    expiredDate: new Date(),
    version: '',
    age: 0,
    docTypeUid: '0',
    docNumber: '',
    lifetime: false,
    cusShop: {
        cusTypeUid: "0",
        creditAmount: 0,
        email: "",
        phoneNo1: "",
        phoneNo2: "",
        phoneNo3: "",
        fingerPrint1Uid: "0",
        fingerPrint2Uid: "0",
        fgTemplate1Uid: "0",
        fgTemplate2Uid: "0",
        warningMsg: "",
        notifyWarning: false,
    }
})


const otpValue = ref("");
const otpTime = ref(null);
const otpResend = ref(null);
const otpMsg = ref('');
const otpRef = ref('');
const otpValidate = ref(0);
const otpReTime = ref(0);
const urls = ref([]);
const secugen_lic = ref('');
const idQuality = ref(100);
const count_scan = ref(0);
const count_fg = ref(0);

const isValid = ref(undefined)
const paused = ref(true)
const result = ref(null)
const error = ref('')
const qr_serach = ref('');
const with_list = ref([]);
const allWith = ref(false)
const qr_scan = ref(false)
const msg_with = ref('')
const uid_list = ref([]);
const canwith = ref(false)
const promotionDetail = ref(null);

const datas = reactive({
    hide: false,
    scanStep: false,
});

const format_h = (date) => {
    return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const format = (date) => {
    return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions_h = {
    format: 'dd/MM/yyyy HH:mm'
};

const textInputOptions = {
    format: 'dd/MM/yyyy'
};

const onClickHandlerH = () => {
    updatePaginationH()
};

const onClickHandlerD = () => {
    updatePaginationD()
};

const onClickHandlerW = () => {
    updatePaginationW()
};

const onClickHandlerC = () => {
    updatePaginationC()
};


const NewTab = async () => {
    sessionStorage.removeItem('deferWorkcaseUid');
    sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
    if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
        const win = window.open("#/generals/defer_items", "_blank");
        win.focus();
        sessionStorage.removeItem('deferWorkcaseUid');
    }
}

function copyBtn() {
    navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const InfoFromSession = async (val) => {
    shop_detail.value = null
    const response = await storeca.cashaccountInfoFromSessionFetch();
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                shop_detail.value = response.data.data
                if (shop_detail.value.fscanLicense !== null) {
                    secugen_lic.value = shop_detail.value.fscanLicense
                }

                if (shop_detail.value.fmatchScore !== 0) {
                    idQuality.value = shop_detail.value.fmatchScore
                }
            }
        }
    }
}

InfoFromSession()

const onserachDate_h = () => {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
};

const onserachDate = () => {
    withTxDate.value = ''
};


const selectedConstraints = ref({ facingMode: 'environment' })

const defaultConstraintOptions = [
    { label: 'rear camera', constraints: { facingMode: 'environment' } },
    { label: 'front camera', constraints: { facingMode: 'user' } }
]
const constraintOptions = ref(defaultConstraintOptions)

/*** track functons ***/

function paintOutline(detectedCodes, ctx) {
    for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

        ctx.strokeStyle = 'red'

        ctx.beginPath()
        ctx.moveTo(firstPoint.x, firstPoint.y)
        for (const { x, y } of otherPoints) {
            ctx.lineTo(x, y)
        }
        ctx.lineTo(firstPoint.x, firstPoint.y)
        ctx.closePath()
        ctx.stroke()
    }
}
function paintBoundingBox(detectedCodes, ctx) {
    for (const detectedCode of detectedCodes) {
        const {
            boundingBox: { x, y, width, height }
        } = detectedCode

        ctx.lineWidth = 2
        ctx.strokeStyle = '#007bff'
        ctx.strokeRect(x, y, width, height)
    }
}
function paintCenterText(detectedCodes, ctx) {
    for (const detectedCode of detectedCodes) {
        const { boundingBox, rawValue } = detectedCode

        const centerX = boundingBox.x + boundingBox.width / 2
        const centerY = boundingBox.y + boundingBox.height / 2

        const fontSize = Math.max(12, (50 * boundingBox.width) / ctx.canvas.width)

        ctx.font = `bold ${fontSize}px sans-serif`
        ctx.textAlign = 'center'

        ctx.lineWidth = 3
        ctx.strokeStyle = '#35495e'
        ctx.strokeText(detectedCode.rawValue, centerX, centerY)

        ctx.fillStyle = '#5cb984'
        ctx.fillText(rawValue, centerX, centerY)
    }
}
const trackFunctionOptions = [
    { text: 'nothing (default)', value: undefined },
    { text: 'outline', value: paintOutline },
    { text: 'centered text', value: paintCenterText },
    { text: 'bounding box', value: paintBoundingBox }
]
const trackFunctionSelected = ref(trackFunctionOptions[1])

function cancelBtnH() {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
    cusUidh_search.value = '';
    cusNameh_search.value = '';
    tkh_search.value = '';
    tknoh_search.value = '';
    typetkh_search.value = '';
    channeltkh_search.value = '';
    listhistory.value = []
    totalRows_sH.value = ''
    currentPageH.value = 1
    time_h.value = false;
}



function cancelBtnD() {
    cusUidd_search.value = '';
    cusNamed_search.value = '';
    tkd_search.value = ''
    listdepo.value = []
    totalRows_Ds.value = ''
    currentPageD.value = 1
}



function cancelBtnW() {
    cusUidw_search.value = '';
    cusNamew_search.value = '';
    tkw_search.value = ''
    tknow_search.value = ''
    withTxDate.value = ''
    time.value = false;
    listwith.value = []
    totalRows_Ws.value = ''
    currentPageW.value = 1
    allWith.value = false
    canwith.value = false

}


async function onClickTab(val) {
    if (val === '1') {
        if (listhistory.value.length === 0) {
            if (cusNameh_search.value !== '' || tkh_search.value !== '') {
                // loadDataApi()
            }
        }
        await setfirstTab()
    } else if (val === '2') {
        await setsecondTab()
    } else if (val === '3') {
        await setthirdTab()
    }
}

function formatNumberString(num) {
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function formatNumberDecimalString(num) {
    if (num !== null && num !== undefined) {
        num = num.toFixed(2)
    } else {
        num = 0
        num = num.toFixed(2)
    }
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function format_datetime(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
    }
}

function format_date(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY')
    }
}

async function loadHistoryListApi() {
    if (cusUidh_search.value !== '' || tkh_search.value !== '' || tknoh_search.value !== '' || typetkh_search.value !== '' || channeltkh_search.value !== '' || time_h.value) {
        currentPageH.value = 1
    }

    let data = "";
    let sd = ''
    let ed = ''
    if (time_h.value) {
        sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
        ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
    }
    data = {
        index: currentPageH.value - 1,
        size: perPageH.value,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        fromDate: sd,
        toDate: ed,
        cusUid: cusUidh_search.value,
        refNumber: tknoh_search.value.trim(),
        tkRefNumber: tkh_search.value.trim(),
        type: typetkh_search.value, //DEPOSIT,WITHDRAW
        channel: channeltkh_search.value, //SHOP, LINE_LIFF
    };
    const payload = data;
    // console.log("lh p : " + JSON.stringify(payload));
    const response = await storedepo.historyFetch(payload);
    // console.log("lh r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listhistory.value = response.data.data.list
                totalRowsH.value = response.data.data.ext.total
                totalRows_sH.value = formatNumberString(totalRowsH.value)
            }
        }
    }
}


async function loadDepositListApi() {
    if (cusUidd_search.value !== '' || tkd_search.value !== '' || tknow_search.value !== '') {
        currentPageD.value = 1
    }

    let data = "";
    data = {
        index: currentPageD.value - 1,
        size: perPageD.value,
        fromDate: "",
        toDate: "",
        cusUid: cusUidd_search.value,
        refNumber: tkd_search.value.trim(),
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storedepo.searchFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listdepo.value = response.data.data.list
                totalRowsD.value = response.data.data.ext.total
                totalRows_Ds.value = formatNumberString(totalRowsD.value)
            }
        }
    }
}


async function loadWithdrawListApi() {
    allWith.value = false
    if (cusUidw_search.value !== '' || tkw_search.value !== '' || tknow_search.value !== '') {
        currentPageW.value = 1
    }
    let data = "";
    let txDate = ''

    if (time.value) {
        txDate = Number(withTxDate.value)
    } else {
        txDate = 0
    }

    data = {
        index: currentPageW.value - 1,
        size: perPageW.value,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: cusUidw_search.value,
        refNumber: tknow_search.value.trim(),
        tkRefNumber: tkw_search.value.trim(),
        channel: '',
        txDate: txDate,
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storedepo.listDepositFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list
                listd.map(function (x) {
                    x.chk = false;
                    return x
                });
                listwith.value = listd
                totalRowsW.value = response.data.data.ext.total
                totalRows_Ws.value = formatNumberString(totalRowsW.value)
            }
        }
    }
}


async function setfirstTab() {
    if (document.getElementById("tab2-tab")) {
        document.getElementById("tab2-tab").classList.remove('show', 'active')
    }

    if (document.getElementById("tab2")) {
        document.getElementById("tab2").classList.remove('show', 'active')
    }

    if (document.getElementById("tab3-tab")) {
        document.getElementById("tab3-tab").classList.remove('show', 'active')
    }

    if (document.getElementById("tab3")) {
        document.getElementById("tab3").classList.remove('show', 'active')
    }

    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.add('show', 'active')
    }
}

async function setsecondTab() {

    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.remove('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.remove('show', 'active')
    }

    if (document.getElementById("tab3-tab")) {
        document.getElementById("tab3-tab").classList.remove('show', 'active')
    }

    if (document.getElementById("tab3")) {
        document.getElementById("tab3").classList.remove('show', 'active')
    }

    if (document.getElementById("tab2-tab")) {
        document.getElementById("tab2-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab2")) {
        document.getElementById("tab2").classList.add('show', 'active')
    }

}

async function setthirdTab() {

    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.remove('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.remove('show', 'active')
    }

    if (document.getElementById("tab2-tab")) {
        document.getElementById("tab2-tab").classList.remove('show', 'active')
    }

    if (document.getElementById("tab2")) {
        document.getElementById("tab2").classList.remove('show', 'active')
    }

    if (document.getElementById("tab3-tab")) {
        document.getElementById("tab3-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab3")) {
        document.getElementById("tab3").classList.add('show', 'active')
    }
}


async function openDialogCusH() {
    cus_search.value = 'H'
    nameThC.value = ''
    nameEnC.value = ''
    docNumberC.value = ''
    cusUidh_search.value = ''
    cusNameh_search.value = ''
    customerlist.value = []
    document.getElementById("searchNameCus").click();
}


async function openDialogCusD() {
    cus_search.value = 'D'
    nameThC.value = ''
    nameEnC.value = ''
    docNumberC.value = ''
    cusUidd_search.value = ''
    cusNamed_search.value = ''
    customerlist.value = []
    document.getElementById("searchNameCus").click();
}


async function openDialogCusW() {
    cus_search.value = 'W'
    nameThC.value = ''
    nameEnC.value = ''
    docNumberC.value = ''
    cusUidw_search.value = ''
    cusNamew_search.value = ''
    customerlist.value = []
    document.getElementById("searchNameCus").click();
}


async function openDialogCusU() {
    cus_search.value = 'U'
    nameThC.value = ''
    nameEnC.value = ''
    docNumberC.value = ''
    cusUidu_search.value = ''
    cusNameu_search.value = ''
    customerlist.value = []
    document.getElementById("searchNameCus").click();
}



async function selectCus(item) {
    if (cus_search.value === 'H') {
        cusUidh_search.value = item.uid
        cusNameh_search.value = item.nameTh
    } else if (cus_search.value === 'D') {
        cusUidd_search.value = item.uid
        cusNamed_search.value = item.nameTh
    } else if (cus_search.value === 'W') {
        cusUidw_search.value = item.uid
        cusNamew_search.value = item.nameTh
    } else if (cus_search.value === 'U') {
        cusUidu_search.value = item.uid
        cusNameu_search.value = item.nameTh
        if (secugen_lic.value !== '') {
            await getCustomerInfo(cusUidu_search.value)
        } else {
            addWithdraw()
        }
    }
    document.getElementById("closeModal").click();
}


async function loadCustomerListApi() {
    currentPageC.value = 1
    let data = "";
    data = {
        index: currentPageC.value - 1,
        size: perPageC.value,
        nameEn: nameEnC.value,
        nameTh: nameThC.value,
        docNumber: docNumberC.value

    };

    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storecus.searchCustomerFetch(payload);
    // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list;
                customerlist.value = listd;
                totalRowsC.value = response.data.data.ext.total
                totalRows_sC.value = formatNumberString(totalRowsC.value)
            }
        }
    }
}

async function updatePaginationH() {
    listhistory.value = []
    let data = "";
    let sd = ''
    let ed = ''
    if (time_h.value) {
        sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
        ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
    }
    data = {
        index: currentPageH.value - 1,
        size: perPageH.value,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        fromDate: sd,
        toDate: ed,
        cusUid: cusUidh_search.value,
        refNumber: tknoh_search.value.trim(),
        tkRefNumber: tkh_search.value.trim(),
        type: typetkh_search.value, //DEPOSIT,WITHDRAW
        channel: channeltkh_search.value, //SHOP, LINE_LIFF
    };
    const payload = data;
    // console.log("lh p : " + JSON.stringify(payload));
    const response = await storedepo.historyFetch(payload);
    // console.log("lh r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listhistory.value = response.data.data.list
                totalRowsH.value = response.data.data.ext.total
                totalRows_sH.value = formatNumberString(totalRowsH.value)
            }
        }
    }

}

async function updatePaginationD() {
    listdepo.value = []
    let data = "";
    data = {
        index: currentPageD.value - 1,
        size: perPageD.value,
        fromDate: "",
        toDate: "",
        cusUid: cusUidd_search.value,
        refNumber: tkd_search.value.trim(),
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storedepo.searchFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listdepo.value = response.data.data.list
                totalRowsD.value = response.data.data.ext.total
                totalRows_Ds.value = formatNumberString(totalRowsD.value)
            }
        }
    }
}

async function updatePaginationW() {
    listwith.value = []
    allWith.value = false
    canwith.value = false
    let data = "";
    let txDate = ''

    if (time.value) {
        txDate = Number(withTxDate.value)
    } else {
        txDate = 0
    }

    data = {
        index: currentPageW.value - 1,
        size: perPageW.value,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: cusUidw_search.value,
        refNumber: tknow_search.value.trim(),
        tkRefNumber: tkw_search.value.trim(),
        channel: '',
        txDate: txDate,
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storedepo.listDepositFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list
                listd.map(function (x) {
                    x.chk = false;
                    return x
                });
                listwith.value = listd
                totalRowsW.value = response.data.data.ext.total
                totalRows_Ws.value = formatNumberString(totalRowsW.value)
            }
        }
    }

}

async function updatePaginationC() {
    customerlist.value = []
    let data = "";
    data = {
        index: currentPageC.value - 1,
        size: perPageC.value,
        nameEn: nameEnC.value,
        nameTh: nameThC.value,
        docNumber: docNumberC.value

    };
    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storecus.searchCustomerFetch(payload);
    // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                customerlist.value = response.data.data.list;
                totalRowsC.value = response.data.data.ext.total
                totalRows_sC.value = formatNumberString(totalRowsC.value)
            }
        }
    }
}


async function onDepositTicketDialog(item) {
    swal({
        title: "ฝากตั๋ว",
        text: "คุณต้องการฝากตั๋วรายการนี้",
        icon: "info",
        allowOutsideClick: false,
        showCloseButton: false,
        showCancelButton: true,
        closeOnConfirm: false,
        focusConfirm: false,
        animation: "slide-from-top",
        confirmButtonText: t('buttons.conf'),
        cancelButtonText: t('buttons.canc'),
    }).then((result) => {
        if (result.isConfirmed) {
            addDeposit(item)
        }
    });
}

async function addDeposit(item) {
    let data = "";
    data = {
        workCaseUid: item.uid,
    };
    const payload = data;
    const response = await storedepo.depositAddFetch(payload);
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                swal("บันทึกสำเร็จ", "", "success");
                loadDepositListApi()
            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }

}


async function setAllTk() {
    canwith.value = false
    for (let i = 0; i < listwith.value.length; i++) {
        if (allWith.value) {
            listwith.value[i].chk = true
            canwith.value = true
        } else {
            listwith.value[i].chk = false
        }
    }
}



async function setTk(item) {
    canwith.value = false
    for (let i = 0; i < listwith.value.length; i++) {
        if (listwith.value[i].chk) {
            canwith.value = true
            break
        }
    }
    if (item.chk === false) {
        if (allWith.value) {
            allWith.value = false
        }
    } else if (item.chk === true) {
        let ck = true
        for (let i = 0; i < listwith.value.length; i++) {
            if (listwith.value[i].chk === false) {
                ck = false
                break
            }
        }
        if (ck) {
            allWith.value = true
        } else {
            allWith.value = false
        }
    }
}

async function onWithdrawTicketDialog() {
    qr_serach.value = ''
    paused.value = false
    with_list.value = []
    qr_scan.value = false
    msg_with.value = ''
    error.value = ''
    with_uid.value = ''
    uid_list.value = []

    for (let i = 0; i < listwith.value.length; i++) {
        if (listwith.value[i].chk) {
            with_list.value.push(listwith.value[i])
        }
    }

    await resetValidationState()
    document.getElementById("withdrawModalShow").click();
}


/*** error handling ***/
function onError(err) {
    error.value = `[${err.name}]: `
    if (err.name === 'NotAllowedError') {
        error.value += 'you need to grant camera access permission'
    } else if (err.name === 'NotFoundError') {
        error.value += 'no camera on this device'
    } else if (err.name === 'NotSupportedError') {
        error.value += 'secure context required (HTTPS, localhost)'
    } else if (err.name === 'NotReadableError') {
        error.value += 'is the camera already in use?'
    } else if (err.name === 'OverconstrainedError') {
        error.value += 'installed cameras are not suitable'
    } else if (err.name === 'StreamApiNotSupportedError') {
        error.value += 'Stream API is not supported in this browser'
    } else if (err.name === 'InsecureContextError') {
        error.value +=
            'Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.'
    } else {
        error.value += err.message
    }

    // document.getElementById("closeqr").click();
    // paused.value = false
    // resetValidationState()
}


async function resetValidationState() {
    isValid.value = undefined
    result.value = ''
}


async function onDetect([firstDetectedCode]) {
    result.value = firstDetectedCode.rawValue
    paused.value = true
    msg_with.value = ''
    error.value = ''
    // pretend it's taking really long
    await timeout(2000)
    isValid.value = result.value
    let lp = with_list.value.filter((c) => c.tkRefNumber === result.value);
    if (lp.length > 0) {
        let ld = uid_list.value.filter((c) => c === lp[0].uid)
        if (ld.length > 0) {
            msg_with.value = result.value + ' เลขที่ตั๋วนี้ถูกยืนยันไปแล้ว :)'
        } else {
            uid_list.value.push(lp[0].uid)
            if (with_uid.value === '') {
                with_uid.value = uid_list.value.length + '. ' + lp[0].tkRefNumber
            } else {
                with_uid.value = with_uid.value + ', ' + uid_list.value.length + '. ' + lp[0].tkRefNumber
            }
        }
    } else {
        msg_with.value = result.value + ' ไม่พบเลขที่ตั๋วนี้ในรายการที่เลือก :)'
        await resetValidationState()
    }
    paused.value = false
    // await resetValidationState()
    //   document.getElementById("closeqr").click();
}

async function onConfirmWith() {
    msg_with.value = ''
    error.value = ''
    let lp = with_list.value.filter((c) => c.tkRefNumber === qr_serach.value.trim());
    if (lp.length > 0) {
        let ld = uid_list.value.filter((c) => c === lp[0].uid)
        if (ld.length > 0) {
            msg_with.value = qr_serach.value.trim() + ' เลขที่ตั๋วนี้ถูกยืนยันไปแล้ว :)'
        } else {
            uid_list.value.push(lp[0].uid)
            if (with_uid.value === '') {
                with_uid.value = uid_list.value.length + '. ' + lp[0].tkRefNumber
            } else {
                with_uid.value = with_uid.value + ', ' + uid_list.value.length + '. ' + lp[0].tkRefNumber
            }
            // msg_with.value = 'ตรวจสอบเลขที่ตั๋วเรียบร้อย'
        }
    } else {
        msg_with.value = qr_serach.value.trim() + ' ไม่พบเลขที่ตั๋วนี้ในรายการที่เลือก :)'
    }
}

function timeout(ms) {
    return new Promise((resolve) => {
        window.setTimeout(resolve, ms)
    })
}

async function addWithdraw() {
    finger_uid.value = '0';
    finger_temp.value = '0';
    if (template_2.value !== '') {
        await uploadFinger()
        if (cus_detail.value.cusShop.fingerPrint1Uid === '0') {
            await addFinger()
        }
    }
    let data = "";
    data = {
        uids: uid_list.value, // always required
        fpImageUid: finger_uid.value,
        fpTemplateUid: finger_temp.value,
        withdrawerUid: cusUidu_search.value,
        withdrawerName: cusNameu_search.value,
    };
    const payload = data;
    // console.log('aW p : ' + JSON.stringify(payload));
    const response = await storedepo.withdrawAddFetch(payload);
    // console.log('aW r : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                swal("บันทึกสำเร็จ", "", "success");
                loadWithdrawListApi()
            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }

}

async function openDetail(wcUid) {
    // console.log('openDetail : ' + JSON.stringify(item));
    workcaseDetail.value = null
    images.value = []
    images_l.value = []
    listinfo.value = []
    tk_status.value = ''
    int_cal.value = 0
    paymentE.value = ''
    int_period.value = ''
    dep_ref.value = ''
    fcusdt.value = false
    bf_changename.value = ''
    af_changename.value = ''
    promotionDetail.value = null

    await getworkCaseInfo(wcUid)
    if (workcaseDetail.value != null) {
        // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
        if (workcaseDetail.value.changeName) {
            af_changename.value = workcaseDetail.value.tkCustomerInfo.name 
            await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
        }

        if (workcaseDetail.value.deposit) {
            await getDepositInfo(workcaseDetail.value.tkRefNumber)
        }
        await detailPayment(workcaseDetail.value.paymentGroupUid)

        images_l.value = workcaseDetail.value.ticket.images
        listinfo.value = workcaseDetail.value.ticket.collaterals
        await calIntInt()
        if (workcaseDetail.value.transactionType !== 'REDEEM') {
            if (workcaseDetail.value.status === 'FINISH') {
                tk_status.value = 'ปกติ'
            } else if (workcaseDetail.value.status === 'FREEZE') {
                tk_status.value = 'อายัด'
            } else if (workcaseDetail.value.status === 'TERMINATE') {
                tk_status.value = 'ยกเลิก'
            } else if (workcaseDetail.value.status === 'ACTIVE') {
                tk_status.value = 'กำลังดำเนินการ'
            } else if (workcaseDetail.value.status === 'BREAKING') {
                tk_status.value = 'ของหลุด'
            }


        } else {
            if (workcaseDetail.value.status === 'FINISH') {
                tk_status.value = 'ไถ่ถอน'
            } else if (workcaseDetail.value.status === 'TERMINATE') {
                tk_status.value = 'ยกเลิก'
            }
        }

        if (workcaseDetail.value.promotionUid !== '0') { 
                await retrieveInfo(workcaseDetail.value)
        }

        if (images_l.value.length > 0) {
            getTicketImage()
        } else {
            let obj = {
                src: noImg,
                thumbnailImageSrc: noImg,
                alt: '',
                title: ''
            }
            images.value.push(obj)
            setGallery()
            document.getElementById("detailModal").click();
        }
    }
}

function setGallery() {

    var i, y = "";

    for (i = 0; i < images.value.length; i++) {
        if (i == 0) {
            y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
                ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
        } else {
            y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
                ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
        }

    }
    document.getElementById("demo1").innerHTML = y;
}


async function getTicketImage() {
    if (images.value.length === 0) {
        let url = []
        images.value = []
        for (let i = 0; i < images_l.value.length; i++) {
            // console.log("logoUid : " + item.images[i].imageUid);
            if (images_l.value[i].imageUid !== "0") {
                url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
            }
        }
        if (url.length > 0) {
            await getFile(url)
            // setTimeout(3000);
            if (images.value.length > 0) {
                setGallery()
                document.getElementById("detailModal").click();

            } else {
                let obj = {
                    src: noImg,
                    thumbnailImageSrc: noImg,
                    alt: '',
                    title: ''
                }
                images.value.push(obj)
                setGallery()
                document.getElementById("detailModal").click();

            }
        } else {
            let obj = {
                src: noImg,
                thumbnailImageSrc: noImg,
                alt: '',
                title: ''
            }
            images.value.push(obj)
            setGallery()
            document.getElementById("detailModal").click();

        }
    } else {
        setGallery()
        document.getElementById("detailModal").click();

    }
}


async function getFile(urls) {
    let file_L = []
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = key.accessToken;
    axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
    const requests = urls.map((url) => axios.get(url));
    await Promise.all(requests).then(allResults => {
        if (allResults) {
            file_L = allResults
            if (file_L !== null) {
                // console.log('file_L : ' + JSON.stringify(file_L))
                for (let i = 0; i < file_L.length; i++) {
                    // console.log('file_L : ' + JSON.stringify(file_L.value[i].data.data.data) + ' file_L 2 : ' + JSON.stringify(file_L.value[i].data.data.name));
                    if (file_L[i].data.data !== null) {
                        const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
                        const data = URL.createObjectURL(file);
                        let obj = {
                            src: data,
                            thumbnailImageSrc: data,
                            alt: '',
                            title: ''
                        }
                        images.value.push(obj)
                    }

                    // console.log('File xx : ', file_L.value[i].file.type + 'File size : ', file_L.value[i].file.size + ' bytes in size  name : ' + file_L.value[i].data.data.name);
                }
            }
        }
    })

}

function getFileFromBase64(string64, fileName) {
    const trimmedString = string64.replace('dataimage/jpegbase64', '');
    // const trimmedString = string64;
    const imageContent = atob(trimmedString);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);

    for (let n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
    }
    var ext = fileName.split('.').pop();
    let type = '';
    if (ext === 'jpg') {
        type = 'image/jpeg'
    } else if (ext === 'png') {
        type = 'image/png'
    }
    const blob = new Blob([buffer], { type });
    return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function getworkCaseInfo(id) {
    let data = "";
    data = {
        uid: id,
    };
    const payload = data;

    const response = await storewc.workCaseinfoFetch(payload);
    // console.log("workCaseInfo : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                workcaseDetail.value = response.data.data
            }
        }
    }
}


async function calIntInt() {
    let postponeDate = ''
    if (workcaseDetail.value.postponeCount != 0) {
        postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
    }
    let data = "";
    let pawnValue = 0
    if (workcaseDetail.value.transactionType != 'REDEEM') {
        pawnValue = workcaseDetail.value.newPawnValue
    } else {
        pawnValue = workcaseDetail.value.pawnValue
    }
    data = {
        pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
        previousTxDate: '',
        postponeDate: postponeDate,
        pawnValue: pawnValue,
        promotionUid: workcaseDetail.value.promotionUid,
        interestUid: workcaseDetail.value.interestUid,
    };
    const payload = data;
    // console.log("calIntInt p : " + JSON.stringify(payload));
    const response = await storei.interestCalculateFetch(payload);
    // console.log("calIntInt r : " + JSON.stringify(response.data));
    let res = ''
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                res = response.data.data
                int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
                int_period.value = res.interestPeriod

            }
        }
    }
}

async function detailPayment(item) {
    // console.log('detailPayment : ' + item);
    let data = "";
    data = {
        uid: item,
    };
    const payload = data;
    const response = await storepay.paymentGroupinfoFetch(payload);

    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                paymentE.value = response.data.data
                filterPayType()
                // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
            }
        }
    }
}

function checkTransaction(str) {
    // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
    let side = ''
    if (str === 'PAWN') {
        side = 'จำนำ'
    } else if (str === 'INTEREST') {
        side = 'ต่อดอกเบี้ย'
    } else if (str === 'REDEEM') {
        side = 'ไถ่ถอน'
    } else if (str === 'INC_PRINCIPLE') {
        side = 'เพิ่มต้น'
    } else if (str === 'DEC_PRINCIPLE') {
        side = 'ลดต้น'
    }
    return side
}

function filterPayType() {
    payment_l.value = []
    let pt = [{ name: 'CASH' },
    { name: 'BANK_TRANSFER' },
    { name: 'CREDIT_CARD' },
    { name: 'CHEQUE' },
    { name: 'PROMPT_PAY_MOBILE' },
    { name: 'PROMPT_PAY_TAX_ID' },
    { name: 'QR_CODE' },
    ]
    let lsum = []
    for (let i = 0; i < pt.length; i++) {
        lsum = filterSumPay(pt[i].name)
        if (lsum.length > 0) {
            payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
        } else {
            payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
        }
    }
}

function filterSumPay(str) {
    let nump = 0, numr = 0, numf = 0
    let lp = paymentE.value.payments.filter((c) => c.type === str);
    if (lp.length > 0) {
        let pay = 0
        let receive = 0
        let fee = 0
        for (let i = 0; i < lp.length; i++) {
            pay = pay + lp[i].pay
            receive = receive + lp[i].receive
            fee = fee + lp[i].feeReceive
            // fee = fee + lp[i].fee
        }
        nump = pay
        numr = receive
        numf = fee
    }
    let lockL = []
    lockL.push({ pay: nump, receive: numr, fee: numf })
    // console.log('lockL : ' + JSON.stringify(lockL));
    return lockL
}


async function getShopInfo() {
    shop_info.value = null
    let data = "";
    data = {
        uid: shop_detail.value.uid,
    };
    const payload = data;
    const response = await storesh.shopInfoFetch(payload);
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                shop_info.value = response.data.data
                // console.log('shop_info : ' + JSON.stringify(shop_info.value));
            }
        }
    }
}


async function pdfHistoryGen() {
    loading.value = true
    if (shop_info.value === null) {
        await getShopInfo()
    }
    let data = "";
    data = {
        page: {
            index: "0",
            size: "0", // size=0 (default) = no page limit
            sort: ""
        },
        filter: {
            groupUid: shop_detail.value.groupUid,
            shopUid: shop_detail.value.uid,
            fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss'),
            toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59'),
            cusUid: cusUidh_search.value,
            refNumber: tknoh_search.value.trim(),
            tkRefNumber: tkh_search.value.trim(),
            type: typetkh_search.value, //DEPOSIT,WITHDRAW
            channel: channeltkh_search.value, //SHOP, LINE_LIFF
            shopName: shop_info.value.fullname,
        }
    };
    // console.log('data : ' + JSON.stringify(data));
    const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = keya.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/pawn-rpt-svc/deposit/history/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    loading.value = false
    // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
    if (response.headers.get("content-type") === 'application/pdf') {

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}


async function pdfDepositGen() {
    loading.value = true
    if (shop_info.value === null) {
        await getShopInfo()
    }
    let data = "";
    let txDate = ''

    if (time.value) {
        txDate = Number(withTxDate.value)
    } else {
        txDate = 0
    }
    data = {
        page: {
            index: "0",
            size: "0", // size=0 (default) = no page limit
            sort: ""
        },
        filter: {
            groupUid: shop_detail.value.groupUid,
            shopUid: shop_detail.value.uid,
            cusUid: cusUidw_search.value,
            refNumber: tknow_search.value.trim(),
            tkRefNumber: tkw_search.value.trim(),
            txDate: txDate,
            channel: '',
            shopName: shop_info.value.fullname,
        }
    };
    // console.log('data : ' + JSON.stringify(data));
    const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = keya.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/pawn-rpt-svc/deposit/list/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    loading.value = false
    // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
    if (response.headers.get("content-type") === 'application/pdf') {

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}


async function uploadFinger() {
    let name = ''
    let date = new Date()
    if (template_2.value !== '') {
        if (cus_detail.value.cusShop !== null) {
            name = 'fingerwithdraw-' + date.getFullYear() + date.getMonth() + 1
                + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds()
            await addFingerApi(name, bmpBase64.value, "image/bmp")
            if (thumb_id.value !== '0') {
                finger_uid.value = thumb_id.value
            }

            name = 'templatewithdraw-' + date.getFullYear() + date.getMonth() + 1
                + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds()
            await addFingerApi(name, template_2.value, "")
            if (thumb_id.value !== '0') {
                finger_temp.value = thumb_id.value
            }
        }

    }
}


async function addFingerApi(name, datafile, type) {
    thumb_id.value = '0'
    let data = "";
    data = {
        name: name + ".bmp",
        data: datafile,
        mimeType: type,
    };

    const payload = data;
    // console.log('addfileApi : ' + JSON.stringify(payload));
    const response = await storedoc.addFetch(payload);
    // console.log('addFingerApi : ' + JSON.stringify(response.data));
    if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
            thumb_id.value = response.data.data.uid
        } else {
            swal("บันทึกไฟล์ไม่สำเร็จ", response.data.rtnDesc, "error");
        }
    }
}


async function updateCustomerShop(action) {
    const payload = cus_detail.value.cusShop;
    // console.log('upf p : ' + JSON.stringify(payload));
    const response = await storecussh.cusShopUpdateFetch(payload)
    // console.log('upf r : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                if (action === 'data') {
                    swal("บันทึกสำเร็จ", "", "success");
                    cus_detail.value.cusShop = response.data.data
                } else if (action === 'finger') {
                    cus_detail.value.cusShop = response.data.data
                }

            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }
}


async function addFinger() {
    let name = ''
    if (template_2.value !== '') {
        if (cus_detail.value.cusShop !== null) {
            let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
            name = 'fingerprint1_' + today
            await addFingerApi(name, bmpBase64.value, "image/bmp")
            if (thumb_id.value !== '0') {
                cus_detail.value.cusShop.fingerPrint1Uid = thumb_id.value
            }

            name = 'template1_' + today
            await addFingerApi(name, template_2.value, "")
            if (thumb_id.value !== '0') {
                cus_detail.value.cusShop.fgTemplate1Uid = thumb_id.value
            }

            if (cus_detail.value.cusShop.fingerPrint1Uid !== '0' && cus_detail.value.cusShop.fgTemplate1Uid !== '0') {
                await updateCustomerShop('finger')

            }
        } else {
            swal("บันทึกไม่สำเร็จ", 'ไม่พบข้อมูลลูกค้าสาขา', "error");
        }
    } else {
        swal("กรุณาสแกนนิ้ว", '', "error");
    }
}


async function getCustomerInfo(uid) {

    let data = "";
    data = {
        uid: uid,
    };

    const payload = data;
    const response = await storecus.customerInfoFetch(payload);
    // console.log("getCustomerInfo : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                cus_detail.value = response.data.data
                // cus_detail.value.cusShop.fingerPrint1Uid = '0'
                // cus_detail.value.cusShop.fingerPrint2Uid = '0'
                // cus_detail.value.cusShop.fgTemplate1Uid = '0'
                // cus_detail.value.cusShop.fgTemplate2Uid = '0'
                if (count_fg.value === 0) {
                    await onScanFinger()
                } else {
                    document.getElementById("fingerModal").click()
                }
            }
        }
    }
}


async function checkbeforeScan(item) {
    cusUidu_search.value = ''
    cusNameu_search.value = ''
    with_uid.value = item.uid
    clearItemCustomerInfo()
    openDialogCusU()
}


async function clearItemCustomerInfo() {
    template_1.value = ''
    template_2.value = ''
    cus_detail.value = {
        nameTh: '',
        nameEn: '',
        birthOrRegDate: new Date(),
        address: {
            address1: "",
            subDistrict: "",
            district: "",
            province: "",
            postcode: "",
            country: ""
        },
        issuedDate: new Date(),
        expiredDate: new Date(),
        version: '',
        age: 0,
        docTypeUid: '0',
        docNumber: '',
        cusShop: {
            cusTypeUid: "0",
            creditAmount: 0,
            email: "",
            phoneNo1: "",
            phoneNo2: "",
            phoneNo3: "",
            fingerPrint1Uid: "0",
            fingerPrint2Uid: "0",
            fgTemplate1Uid: "0",
            fgTemplate2Uid: "0",
            warningMsg: "",
            notifyWarning: false,
        }
    }
}



async function onScanFinger() {
    CallSGIFPGetData(SuccessFunc2, ErrorFunc)
    matchResult.value = 0
    count_scan.value = 0
    template_1.value = ''
    template_2.value = ''
    urls.value = []
    if (urls.value.length === 0) {
        templatef_1.value = '';
        templatef_2.value = '';
        bmpBase64f_1.value = '';
        bmpBase64f_2.value = '';
        if (cus_detail.value.cusShop.fingerPrint1Uid !== '0') {
            urls.value.push(String(st.url_api + "/doc-svc/document/info/" + cus_detail.value.cusShop.fingerPrint1Uid));
        }
        if (cus_detail.value.cusShop.fgTemplate1Uid !== '0') {
            urls.value.push(String(st.url_api + "/doc-svc/document/info/" + cus_detail.value.cusShop.fgTemplate1Uid));
        }
        if (cus_detail.value.cusShop.fingerPrint2Uid !== '0') {
            urls.value.push(String(st.url_api + "/doc-svc/document/info/" + cus_detail.value.cusShop.fingerPrint2Uid));
        }
        if (cus_detail.value.cusShop.fgTemplate2Uid !== '0') {
            urls.value.push(String(st.url_api + "/doc-svc/document/info/" + cus_detail.value.cusShop.fgTemplate2Uid));
        }

        if (urls.value.length > 0) {
            await getFilefinger()
            if (bmpBase64f_1.value !== '') {
                document.getElementById('FPImage1').src = bmpBase64f_1.value
                template_1.value = templatef_1.value
            } else if (bmpBase64f_2.value !== '') {
                document.getElementById('FPImage1').src = bmpBase64f_2.value
                template_1.value = templatef_2.value
            }
            document.getElementById('FPImage2').src = nofinger
            document.getElementById("fingerModal").click()
        } else {
            document.getElementById('FPImage2').src = nofinger
            document.getElementById("fingerModal").click()
        }

    } else if (bmpBase64f_1.value !== '' || bmpBase64f_2.value !== '') {
        if (bmpBase64f_1.value !== '') {
            document.getElementById('FPImage1').src = bmpBase64f_1.value
            template_1.value = templatef_1.value
        } else if (bmpBase64f_2.value !== '') {
            document.getElementById('FPImage1').src = bmpBase64f_2.value
            template_1.value = templatef_2.value
        }
        document.getElementById('FPImage2').src = nofinger
        document.getElementById("fingerModal").click()
    } else {
        document.getElementById('FPImage2').src = nofinger
        document.getElementById("fingerModal").click()
    }

}


function SuccessFunc2(result) {
    if (result.ErrorCode == 0) {
        /* 	Display BMP data in image tag
            BMP data is in base 64 format 
        */
        if (result != null && result.BMPBase64.length > 0) {
            document.getElementById('FPImage2').src = "data:image/bmp;base64," + result.BMPBase64;
            bmpBase64.value = result.BMPBase64
        }
        template_2.value = result.TemplateBase64;
        if (template_1.value !== "" && template_2.value !== "") {
            startMatch()
        }
    }
    else {
        console.log("Fingerprint Capture Error Code:  " + result.ErrorCode + ".\nDescription:  " + ErrorCodeToString(result.ErrorCode) + ".")
    }
}

function ErrorFunc(status) {
    /* 	
        If you reach here, user is probabaly not running the 
        service. Redirect the user to a page where he can download the
        executable and install it. 
    */
    // alert("Check if SGIBIOSRV is running; status = " + status + ":");
    console.log("Check if SGIBIOSRV is running; status = " + status + ":")
}

function CallSGIFPGetData(successCall, failCall) {
    template_2.value = ''
    matchResult.value = 0
    document.getElementById('FPImage2').src = nofinger
    var uri = "https://localhost:8443/SGIFPCapture";
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            let fpobject = JSON.parse(xmlhttp.responseText);
            successCall(fpobject);
        }
        else if (xmlhttp.status == 404) {
            failCall(xmlhttp.status)
        }
    }
    xmlhttp.onerror = function () {
        failCall(xmlhttp.status);
    }
    var params = "Timeout=" + "10000";
    params += "&Quality=" + "50";
    params += "&licstr=" + encodeURIComponent(secugen_lic.value);
    params += "&templateFormat=" + "ISO";
    xmlhttp.open("POST", uri, true);
    xmlhttp.send(params);
}

function startMatch() {
    if (template_1.value == "" || template_2.value == "") {
        alert("Please scan two fingers to verify!!");
        return;
    } else {
        count_scan.value = 0
        matchScore(succMatch, failureFunc)
    }
}

function matchScore(succFunction, failFunction) {

    var uri = "https://localhost:8443/SGIMatchScore";

    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            let fpobject = JSON.parse(xmlhttp.responseText);
            succFunction(fpobject);
        }
        else if (xmlhttp.status == 404) {
            failFunction(xmlhttp.status)
        }
    }

    xmlhttp.onerror = function () {
        failFunction(xmlhttp.status);
    }
    var params = "template1=" + encodeURIComponent(template_1.value);
    params += "&template2=" + encodeURIComponent(template_2.value);
    params += "&licstr=" + encodeURIComponent(secugen_lic.value);
    params += "&templateFormat=" + "ISO";
    xmlhttp.open("POST", uri, false);
    xmlhttp.send(params);
}

function succMatch(result) {
    // var idQuality = document.getElementById("quality").value;
    matchResult.value = 0

    if (result.ErrorCode == 0) {
        matchResult.value = Number(result.MatchingScore)
        if (result.MatchingScore >= idQuality.value) {
            // alert("MATCHED ! (" + result.MatchingScore + ")");
        } else {
            // alert("NOT MATCHED ! (" + result.MatchingScore + ")");
            if (bmpBase64f_1.value !== '' && bmpBase64f_2.value !== '' && count_scan.value === 0) {
                findOtherfinger()
            } else {
                if (count_scan.value === 0) {
                    count_fg.value = count_fg.value + 1
                }
            }

        }
    } else {
        alert("Error Scanning Fingerprint ErrorCode = " + result.ErrorCode);
    }
}

function failureFunc(error) {
    alert("On Match Process, failure has been called");
}

function findOtherfinger() {
    count_scan.value = 1
    if (template_1.value === templatef_1.value) {
        document.getElementById('FPImage1').src = bmpBase64f_2.value
        template_1.value = templatef_2.value
        matchScore(succMatch, failureFunc)
    } else if (template_1.value === templatef_2.value) {
        document.getElementById('FPImage1').src = bmpBase64f_1.value
        template_1.value = templatef_1.value
        matchScore(succMatch, failureFunc)
    }
    if (Number(matchResult.value) < idQuality.value) {
        count_fg.value = count_fg.value + 1
    }
}



function ErrorCodeToString(ErrorCode) {
    var Description;
    switch (ErrorCode) {
        // 0 - 999 - Comes from SgFplib.h
        // 1,000 - 9,999 - SGIBioSrv errors 
        // 10,000 - 99,999 license errors
        case 51:
            Description = "System file load failure";
            break;
        case 52:
            Description = "Sensor chip initialization failed";
            break;
        case 53:
            Description = "Device not found";
            break;
        case 54:
            Description = "Fingerprint image capture timeout";
            break;
        case 55:
            Description = "No device available";
            break;
        case 56:
            Description = "Driver load failed";
            break;
        case 57:
            Description = "Wrong Image";
            break;
        case 58:
            Description = "Lack of bandwidth";
            break;
        case 59:
            Description = "Device Busy";
            break;
        case 60:
            Description = "Cannot get serial number of the device";
            break;
        case 61:
            Description = "Unsupported device";
            break;
        case 63:
            Description = "SgiBioSrv didn't start; Try image capture again";
            break;
        default:
            Description = "Unknown error code or Update code to reflect latest result";
            break;
    }
    return Description;
}


async function getFilefinger() {
    let file_L = []
    const keyA = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = keyA.accessToken;
    axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
    const requests = urls.value.map((url) => axios.get(url));
    await axios.all(requests).then(allResults => {
        if (allResults) {
            file_L = allResults
            if (file_L !== null) {

                for (let i = 0; i < file_L.length; i++) {
                    // console.log('file_L : ' + JSON.stringify(file_L[i].data.data) + ' file_L 2 : ' + JSON.stringify(file_L[i].data.data.name));
                    if (file_L[i].data.data !== null) {
                        if (file_L[i].data.data.name.includes('fingerprint1')) {
                            // document.getElementById('FPImage1').src = "data:image/bmp;base64," + file_L[i].data.data.data;
                            bmpBase64f_1.value = "data:image/bmp;base64," + file_L[i].data.data.data;
                        } else if (file_L[i].data.data.name.includes('fingerprint2')) {
                            // document.getElementById('FPImage2').src = "data:image/bmp;base64," + file_L[i].data.data.data;
                            bmpBase64f_2.value = "data:image/bmp;base64," + file_L[i].data.data.data;
                        } else if (file_L[i].data.data.name.includes('template1')) {
                            // document.getElementById('FPImage2').src = "data:image/bmp;base64," + file_L[i].data.data.data;
                            templatef_1.value = file_L[i].data.data.data;
                        } else if (file_L[i].data.data.name.includes('template2')) {
                            // document.getElementById('FPImage2').src = "data:image/bmp;base64," + file_L[i].data.data.data;
                            templatef_2.value = file_L[i].data.data.data;
                        }

                    }
                }
            }
        }
    })
}

async function requestOTP() {
    if (cus_detail.value.cusShop.phoneNo1 === null || cus_detail.value.cusShop.phoneNo1 === '') {
        swal("กรุณาเพิ่มเบอร์มือถือ", "", "error");
    } else {
        if (otpTime.value) {
            const myModal = document.getElementById('otpModal');
            const modal = new Modal(myModal); // Instantiates your modal
            modal.show();
        } else {
            await generateOTP('new')
        }
    }
}


async function generateOTP(val) {
    otpMsg.value = ''
    otpRef.value = ''
    let data = "";
    data = {
        userLevel: 'customer',
        userUid: cus_detail.value.uid,
        transactionUid: cus_detail.value.uid,
    };
    const payload = data;
    userSStore.generateOTP(payload).then((data) => {
        // console.log("generateOTP x : ", JSON.stringify(data));
        otpRef.value = data.otpPrefix
        otpValidate.value = data.validity
        if (otpRef.value !== '' && otpValidate.value !== null && val === 'new') {
            onOpenOTPModal()
        } else if (otpRef.value !== '' && otpValidate.value !== null && val === 'resend') {
            otpValue.value = ''
            otpTime.value = true
            otpResend.value = true
            otpReTime.value = 30
            timerOtp(true)
            timerResend(true)
        }
    }).catch((err) => {
        if (err.response) {
            console.error("", err);
            otpMsg.value = 'ไม่สำเร็จ : ' + err.response.data.message
            otpReTime.value = 30
            timerResend(true)
        }
    });
}

async function validateOTP() {
    otpMsg.value = ''
    let data = "";
    data = {
        transactionUid: cus_detail.value.uid,
        otpPrefix: otpRef.value,
        otp: otpValue.value,
    };

    const payload = data;
    userSStore.validateOTP(payload).then((data) => {
        // console.log("validateOTP x : ", JSON.stringify(data));
        otpMsg.value = data.message
        if (data.message === 'OK') {
            document.getElementById("closeOtp").click()
            otpValidate.value = 1
            timerOtp(false)
            otpReTime.value = 1
            timerResend(false)
            addWithdraw()
        }
    }).catch((err) => {
        if (err.response) {
            console.error("", err);
            otpMsg.value = 'ไม่สำเร็จ : ' + err.response.data.message
            otpValidate.value = 1
            timerOtp(false)
            if (document.getElementById('timer-otp')) {
                document.getElementById('timer-otp').innerHTML = '00:00';
            }

        }
    });
}

async function validateOTPNew() {
  otpMsg.value = ''  
  if (otpValue.value === '888988') {
      document.getElementById("closeOtp").click()
      otpValidate.value = 1
      timerOtp(false)
      otpReTime.value = 1
      timerResend(false)
      addWithdraw()
  }else{
    otpMsg.value = 'ไม่สำเร็จ'
  }
}

async function onOpenOTPModal() {
    otpValue.value = ''
    otpMsg.value = ''
    otpTime.value = true
    otpResend.value = true
    const myModal = document.getElementById('otpModal');
    const modal = new Modal(myModal); // Instantiates your modal
    modal.show();
    timerOtp(true)
    otpReTime.value = 30
    timerResend(true)
}
async function onOpenFingerScan() {
    document.getElementById("closeOtp").click()
    document.getElementById("fingerModal").click()
}

function timerOtp(timerOn) {
    var m = Math.floor(otpValidate.value / 60);
    var s = otpValidate.value % 60;
    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    if (document.getElementById('timer-otp')) {
        document.getElementById('timer-otp').innerHTML = m + ':' + s;
    }

    otpValidate.value -= 1;



    if (otpValidate.value >= 0 && timerOn) {
        setTimeout(function () {
            timerOtp(otpValidate.value, timerOn);
        }, 1000);
        return;
    }


    if (otpValidate.value <= 0) {
        otpTime.value = false
    }


    if (!timerOn) {
        // Do validate stuff here
        return;
    }
    // Do timeout stuff here


}


function timerResend(timerOn) {
    var m = Math.floor(otpReTime.value / 60);
    var s = otpReTime.value % 60;
    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    if (document.getElementById('timer-resend')) {
        document.getElementById('timer-resend').innerHTML = m + ':' + s;
    }
    otpReTime.value -= 1;

    if (otpReTime.value >= 0 && timerOn) {
        setTimeout(function () {
            timerResend(timerOn);
        }, 1000);
        return;
    }

    if (otpReTime.value <= 0) {
        otpResend.value = false
    }

    if (!timerOn) {
        // Do validate stuff here
        return;
    }
    // Do timeout stuff here
}


async function getDepositInfo(tkRef) {
    let data = "";
    data = {
        index: 0,
        size: 1,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: '',
        refNumber: '',
        tkRefNumber: tkRef.trim(),
        channel: '',
        txDate: 0,
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storedepo.listDepositFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list
                dep_ref.value = listd[0].refNumber
            }
        }
    }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
      }
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }
  data = {
    cusUid : item.customerInfo.customerUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        promotionDetail.value = res
      }
    }
  }
}

onMounted(() => {
    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.add('show', 'active')
    }
});


</script>
<style lang="scss" scoped>
.inline-icon {
    display: inline-flex;
    vertical-align: top;
    font-size: 20px !important;
}

.loading-state {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid-container {
    max-width: 990px;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
}

.btnClose {
    border-color: transparent !important;
    background-color: white !important;
    vertical-align: baseline;

    i.material-icons {
        padding-top: 8px;
        color: gray-600;
    }
}

.grid-containerP {
    max-width: 990px;
    display: grid;
    grid-gap: 1px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
    position: relative;
}

.myLayer {
    position: absolute;
    /* becomes a layer */
    // left: 0;
    /* relative to its parent wrapper */
    top: -18px;
    right: -23px;
    /* relative to its parent wrapper */
    z-index: 2;
    font-size: 20px;
}
</style>